<template>
  <div class="container">
    <div class="row mt-4 mb-3">
      <div class="col-12">
        <h3>Contractoverzicht</h3>
      </div>
    </div>
    <div class="row text-center">
      <table class="table table-borderless">
        <tbody>
        <tr>
          <td class="col-3"></td>
          <td class="col-3 font-weight-bold align-left">Gebruiker</td>
          <td class="col-3">{{  selectedContract.username }}</td>
          <td class="col-3"></td>
        </tr>
        <tr>
          <td class="col-3"></td>
          <td class="col-3 font-weight-bold align-left">Klant</td>
          <td class="col-3">{{  selectedContract.customerName }}</td>
          <td class="col-3"></td>
        </tr>
        <tr>
          <td class="col-3"></td>
          <td class="col-3 font-weight-bold align-left">Contractperiode</td>
          <td v-if="selectedContract.datePeriod.endDate" class="col-3">{{  formattedDate(selectedContract.datePeriod.startDate) }} - {{  formattedDate(selectedContract.datePeriod.endDate) }}</td>
          <td v-else class="col-3">{{  formattedDate(selectedContract.datePeriod.startDate) }} (met onbepaalde duur)</td>
          <td class="col-3"></td>
        </tr>
        <tr>
          <td class="col-3"></td>
          <td class="col-3 font-weight-bold align-left">Referentie</td>
          <td class="col-3">{{  selectedContract.reference }}</td>
          <td class="col-3"></td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="row d-flex align-items-center">
      <div class="mb-1 col-lg-12">
        <h4 class="d-inline-block mt-5">Orders</h4>
      </div>
    <div class="row col-12 mt-1">
      </div>
      <table class="table table-borderless">
        <thead class="thead-dark">
        <tr class="d-flex">
          <th scope="col" class="col-2"></th>
          <th scope="col" class="col-3">Tarief</th>
          <th scope="col" class="col-3">Start</th>
          <th scope="col" class="col-4">Einde</th>
        </tr>
        </thead>
        <tbody  v-for="(rate, index) in sortedOrders" :key="index" :style=decideColorForTableRow(index)>
          <tr class="d-flex">
            <th scope="row" class="col-2">{{index+1}}</th>
            <td class="col-3">{{rate.baseHourlyRate}}</td>
            <td class="col-3">{{formattedDate(rate.startDate)}}</td>
            <td class="col-4">{{formattedDate(rate.endDate)}}</td>
          </tr>
          <tr v-if="rate.internalReference != null" class="d-flex">
            <th scope="row" class="col-2 text-right">&#x27A5;</th>
            <td class="col-3 text-center">Interne referentie:</td>
            <td class="col-7 text-center">{{ rate.internalReference }}</td>
          </tr>
          <tr v-if="rate.externalReference != null" class="d-flex">
            <th scope="row" class="col-2 text-right">&#x27A5;</th>
            <td class="col-3 text-center">Externe Referentie:</td>
            <td class="col-7 text-center">{{ rate.externalReference }}</td>
          </tr>
          <tr class="d-flex">
            <td class="col-12 text-right">
              <button :disabled="isEditing(rate)"
                  @click="showEdit(rate)" style="width: 200px" class="btn-basic btn-gold">Order aanpassen</button>
            </td>
          </tr>
          <tr v-if="rate === chosenRate">
            <td colspan="6" class="p-0">
              <EditContractComponent
                  v-if="toggleUpdateMessage"
                  :contractId="rate.id"
                  :order-to-edit="rate"
                  :dates-from-all-orders="datesFromAllOrders"
                  @hourlyRateUpdated="toggle"
                  @orderCanceled="toggle"/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {toDateMonthYear} from "@/util/DateUtil";
import {sortListByColumnAndDirection} from "@/util/SortingUtil";
import EditContractComponent from "@/components/EditContract/EditContractComponent.vue";

export default {
  name: "AdminContractDetail",
  components: {EditContractComponent},
  data: () => ({
    toggleUpdateMessage: false,
    chosenRate: null,
    datesFromAllOrders: []
  }),
  computed: {
    ...mapGetters({
      selectedContract: "administrationContract/selectedContract",
    }),
    sortedOrders: function () {
      return sortListByColumnAndDirection(this.selectedContract.orders, "baseHourlyRate", false);
    }
  },
  methods: {
    ...mapActions("administrationContract", ["updateOrder"]),
    decideColorForTableRow(index) {
      if (index % 2 === 0) {
        return "background-color: white";
      } else {
        return "background-color: lightgrey";
      }
    },
    formattedDate(date) {
      return toDateMonthYear(date);
    },
    showEdit(chosenRate) {
      this.chosenRate = chosenRate;
      this.datesFromAllOrders = this.getDatesFromAllOrders(this.sortedOrders.filter(order => order !== chosenRate));
      this.toggleUpdateMessage = true;
    },
    toggle() {
      this.chosenRate = null;
      this.datesFromAllOrders = [];
      this.toggleUpdateMessage = false;
    },
    isEditing(rate) {
      return rate === this.chosenRate && this.toggleUpdateMessage;
    },
    getDatesFromAllOrders(orders) {
      var takenPeriodsFromOrders = [];
      orders.forEach(order => takenPeriodsFromOrders.push(order.startDate + " Tot " + order.endDate));
      return takenPeriodsFromOrders;
    }
  }
};
</script>

<style scoped>
.align-left {
  text-align: left;
}
</style>